<template>
  <div class="fill">
    <van-field
      readonly
      clickable
      name="picker"
      :value="answer"
      label=""
      placeholder="点击选择机构"
      @click="showPicker = true"
    />
    <van-popup
      v-model="showPicker"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        value-key="name"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "selectTree",
  mixins: [mixins],
  data() {
    return {
      answer: null,
      showPicker: false,
      columns: [],
    };
  },
  watch: {
    question: {
      handler(newVal) {
        console.log(newVal);
        if (newVal.default_value && this.first) {
          this.answer = newVal.default_value;
          this.change(newVal.default_value);
        }
        this.first = false;
      },
      immediate: true,
    },
  },
  created() {
    this.initOptions();
  },
  methods: {
    initOptions() {
      const { question } = this;
      const options = JSON.parse(question.datasource);
      options.forEach((option) => {
        if (option.items.length === 0) {
          option.children = [
            {
              name: "",
            },
          ];
          return;
        }
        option.children = [];
        option.items.forEach((item) => {
          option.children.push({
            name: item,
          });
        });
      });
      this.columns = options;
    },
    onConfirm(item) {
      this.answer = item.filter((item) => !!item).join(",");
      this.showPicker = false;
      this.answerChange({
        level2: item[0],
        level3: item[1],
      });
    },
    // change(value) {
    //   this.answerChange(value)
    // },
  },
};
</script>

<style lang="scss" scoped>
.van-cell {
  border: 1px solid #dcdfe6;
  border-radius: 5px;
}
</style>